module.exports = __webpack_public_path__ + "static/media/jeff.4957da84.jpg";